// use jquery from wordpress. place in module if needed
window.$ = window.jQuery = jQuery;

import { afterScroll } from './helpers/utils.js';
import { lazy } from './helpers/lazyLoading';
import { classtoggler } from 'classtoggler';
import axios from 'axios';
import { Modal } from './modules/modal.js';

//*******************************************************
// sticky navigation
//*******************************************************

afterScroll(() => {
   if (window.scrollY > 0) {
      document.body.classList.add('scroll');
   } else {
      document.body.classList.remove('scroll');
   }
});

//*******************************************************
// classtoggler
// use for class toggling via click in the markup
// https://www.npmjs.com/package/classtoggler/v/1.3.3
//*******************************************************

classtoggler();

//*******************************************************
// lazy loading
//*******************************************************

lazy();

//*******************************************************
// SIDEBAR — body scroll lock + Escape key
// (open/close handled by classtoggler via data-toggler-target)
//*******************************************************

const navSidebar = document.getElementById('nav-sidebar');

if (navSidebar) {
   const hamburger = document.querySelector('.hamburger[data-toggler-target="#nav-sidebar"]');

   // Sync both body scroll lock and hamburger state whenever sidebar active changes
   new MutationObserver(() => {
      const isOpen = navSidebar.classList.contains('active');
      document.body.classList.toggle('sidebar-open', isOpen);
      hamburger?.classList.toggle('active', isOpen);
   }).observe(navSidebar, { attributes: true, attributeFilter: ['class'] });

   // Close on Escape
   document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navSidebar.classList.contains('active')) {
         navSidebar.classList.remove('active');
      }
   });
}

//*******************************************************
// FRONTPAGE
//*******************************************************

//*******************************************************
// SPLIT BLOCK — video controls
//*******************************************************

document.querySelectorAll('.split-block__image-col').forEach(col => {
   const video = col.querySelector('.split-block__video');
   if (!video) return;

   video.addEventListener('play',  () => col.classList.remove('is-paused'));
   video.addEventListener('pause', () => col.classList.add('is-paused'));

   col.classList.toggle('is-muted', video.muted);

   col.querySelector('.split-block__video-btn--play')?.addEventListener('click', () => {
      video.paused ? video.play() : video.pause();
   });

   col.querySelector('.split-block__video-btn--mute')?.addEventListener('click', () => {
      video.muted = !video.muted;
      col.classList.toggle('is-muted', video.muted);
   });
});

//*******************************************************
// FRONTPAGE
//*******************************************************

const asyncBtn = document.querySelector('.js-asyncPostGet');
if (asyncBtn) {
   // prepare a modal to show the async data in it
   const modal = new Modal();

   asyncBtn.addEventListener('click', () => {
      const data = new FormData();
      data.append('action', 'ajax_get_post');
      data.append('postID', 1);
      asyncBtn.classList.add('btn--loading');
      axios.post(settings.ajaxurl, data).then((response) => {
         console.log(response);
         asyncBtn.classList.remove('btn--loading');
         modal.open();
         modal.loadContent(`
            <div class="p-3">
               <div class="bg-fourth p-3">
                  <p>Woooow you just fetched the post ID: ${response.data.id}</p>
                  <p>opened a modal</p>
                  <p>and loaded some post data into it</p>
                  <p>like the title: <strong>${response.data.title}</strong></p>
               </div>
            </div>
         `);
      });
   });
}
